import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { getReportVariantFromPathname } from 'store/licenseManager/reportRouteHelpers'
import { operations as reportsOperations } from 'store/reportsManager'
import { REPORT_VARIANT } from 'pages/LessonCompletionReport/constants'
import { navigationEvent } from 'layers/navigation/store/operations'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { createSiteOptions } from 'components/ReportsNavHeader/helpers'
import ReportsPageHeader from './component'
import { buildAdminDashboardBackPath } from './constants'

export const ReportsPageHeaderContainer = ({
  administratorsCount,
  adminDashboardBackPath,
  gradeNameForUnitNavigation,
  hasClassesWithCompletedLessonLastPeriod,
  numClassesWithCompletedLessonLastPeriod,
  period,
  entry,
  gradeOrSiteName,
  hasDwbAccess,
  isDwbReportRoute,
  isSchoolSummary,
  k8ReportUnitSection,
  lastUpdatedAt,
  navigationHandler,
  navigationEvent,
  reportSites,
  selectedSite,
  sites,
  teachersCount,
  tooltipText,
  totalClassesCount,
  updateSelectedSite,
  updateSelectedProgram,
}) => {
  const navigateTo = url => {
    const programKey = url
      .match(/\/admin\/program\/([^/]+)/)?.[1]
      ?.toUpperCase()

    if (programKey) {
      updateSelectedProgram({ key: programKey, name: programKey })
    }

    navigationEvent(url, NavigationHelper.types.PUSH)
  }

  const rawSites = Array.isArray(sites) ? sites : []
  const siteOptions = createSiteOptions(rawSites)
  const selectedSiteOption = siteOptions.find(
    ({ key }) => key === selectedSite || String(key) === String(selectedSite),
  )

  return (
    <ReportsPageHeader
      adminDashboardBackPath={adminDashboardBackPath}
      administratorsCount={administratorsCount}
      entry={entry}
      gradeNameForUnitNavigation={gradeNameForUnitNavigation}
      gradeOrSiteName={gradeOrSiteName}
      hasClassesWithCompletedLessonLastPeriod={
        hasClassesWithCompletedLessonLastPeriod
      }
      hasDwbAccess={hasDwbAccess}
      isDwbReportRoute={isDwbReportRoute}
      isSchoolSummary={isSchoolSummary}
      k8ReportUnitSection={k8ReportUnitSection}
      lastUpdatedAt={lastUpdatedAt}
      navigateTo={navigateTo}
      navigationEvent={navigationEvent}
      navigationHandler={navigationHandler}
      numClassesWithCompletedLessonLastPeriod={
        numClassesWithCompletedLessonLastPeriod
      }
      period={period}
      reportSites={reportSites}
      selectedSite={selectedSite}
      selectedSiteOption={selectedSiteOption}
      siteOptions={siteOptions}
      teachersCount={teachersCount}
      tooltipText={tooltipText}
      totalClassesCount={totalClassesCount}
      updateSelectedSite={updateSelectedSite}
    />
  )
}

ReportsPageHeaderContainer.propTypes = {
  adminDashboardBackPath: PropTypes.string,
  administratorsCount: PropTypes.number,
  entry: PropTypes.object,
  gradeNameForUnitNavigation: PropTypes.string,
  gradeOrSiteName: PropTypes.string,
  hasClassesWithCompletedLessonLastPeriod: PropTypes.bool,
  hasDwbAccess: PropTypes.bool,
  isDwbReportRoute: PropTypes.bool,
  isSchoolSummary: PropTypes.bool,
  k8ReportUnitSection: PropTypes.string,
  lastUpdatedAt: PropTypes.string,
  navigationEvent: PropTypes.func,
  navigationHandler: PropTypes.func,
  numClassesWithCompletedLessonLastPeriod: PropTypes.number,
  period: PropTypes.number,
  reportSites: PropTypes.arrayOf(PropTypes.object),
  selectedSite: PropTypes.number,
  sites: PropTypes.arrayOf(PropTypes.object),
  teachersCount: PropTypes.number,
  tooltipText: PropTypes.string,
  totalClassesCount: PropTypes.number,
  updateSelectedProgram: PropTypes.func,
  updateSelectedSite: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const { selectedSite, selectedProgram } = state?.reportsManager || {}
  const pathname = state?.router?.location?.pathname
  const isDwbReportRoute =
    ownProps.isDwbReportRoute ??
    getReportVariantFromPathname(pathname) === REPORT_VARIANT.DWB
  const reportSites = licenseSelectors.selectActiveAdminDwbReportSites(state)
  const adminK8SitesWithDwb = licenseSelectors.selectActiveAdminK8SitesWithDwb(
    state,
  )
  const hasDwbAccess =
    isDwbReportRoute ||
    !!adminK8SitesWithDwb?.find(site => site.id === selectedSite)
  const recentLeaderDashboardUrl =
    state.userSessionManager?.adminDashboard?.recentLeaderDashboardUrl
  const adminDashboardBackPath = buildAdminDashboardBackPath({
    isDwbReportRoute,
    k8ReportUnitSection: ownProps.k8ReportUnitSection,
    recentLeaderDashboardUrl,
    selectedProgramKey: selectedProgram?.key,
  })

  return {
    adminDashboardBackPath,
    hasDwbAccess,
    isDwbReportRoute,
    reportSites,
    selectedSite: state.reportsManager?.selectedSite,
    sites: reportSites,
  }
}

const mapDispatchToProps = {
  navigationEvent,
  updateSelectedProgram: reportsOperations.updateSelectedProgram,
  updateSelectedSite: reportsOperations.updateSelectedSite,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportsPageHeaderContainer)
